/** Validation Rules  */
export const isRequired = (value: string): boolean => value !== "";

export const isNumber = (value: string): boolean => {
  const regex = RegExp("^\\d+$");
  return regex.test(value);
};

export const exactLength = (len: number) => (value: string): boolean =>
  value.toString().length === len;

export const maxLength = (len: number) => (value: string): boolean =>
  value.toString().length <= len;

export const minLength = (len: number) => (value: string): boolean =>
  value.toString().length >= len;

export const isValidWebsite = (url: string) => {
  // technically valid website URLs must start with http:// or https://
  // but we allow users to enter URLs without the protocol i.e. www.bestsite.com
  if (!url.includes("://")) {
    url = `http://${url}`;
  }

  // We've had merchants enter this multiple times so adding an additional validation check
  // to ensure that this doesn't happen
  if (url.includes("www.www")) {
    return false;
  }

  // from hub :-)
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator

  return !!pattern.test(url);
};

// https://emailregex.com/
export const isValidEmail = (value: string): boolean =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  );

export const isValidCanadaPostalCode = (value: string): boolean =>
  /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(value);

export const isEmptyString = (value: string): boolean => value === "";

export const isValidWebsiteOrEmpty = (value: string): boolean =>
  isEmptyString(value) || isValidWebsite(value);

export const isExactLengthAndNotEmpty = (len: number) => (
  value: string
): boolean => isEmptyString(value) || value.toString().length === len;

export const defaultMessages = {
  isRequired: "Value required",
  isNumber: "Must be a number",
  isValidEmail: "Must be a valid email",
  isValidPhoneNumber: "Must be a valid phone number",
  isWebsite: "Must be a valid website",
  exactLength: (len: number) => `Must be ${len} characters`,
  minLength: (len: number) => `Min length ${len}`,
  maxLength: (len: number) => `Max length ${len}`,
};
